import React from 'react';

import KeycloakWrapper from '../Keycloak/KeycloakWrapper';
import Admin from '../Admin/Admin';

class AdminAuthWrapper extends React.PureComponent {
  render(): React.ReactElement {
    return (
      <KeycloakWrapper>
        <Admin />
      </KeycloakWrapper>
    );
  }
}

export default AdminAuthWrapper;
